import store from "@/store";
import Lockr from "lockr";
import axios from "axios";
import {getPublicKeyApi} from '@/api/common'

//配置信息
import config from '@/config'

//多语种
import i18n from '@/utils/i18n'

function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}

const cache={
    isFalseLog:false,

    //是否是webview
    isWebview(useragent) {
        var regex = '(WebView|(iPhone|iPod|iPad)(?!.*Safari\/)|Android.*(wv|.0.0.0))';
        return Boolean(useragent.match(regex));
    },

    //是否是IOS
    isIOSPd(){
        var u = window.navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
            return true
        }else{
            return false
        }
    },

    //是否是安卓
    isAndroidPd(){
        var u = window.navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        if (isAndroid) {
            return true
        }else{
            return false
        }
    },

    //提交日志
    submitLog(){
        return false;
    },

    //获取语种
    getLanuageType(lang){
        let newlang=['en','zh-hk','zh-cn']
        let xlang=''
        if(isNumber(lang)){
            if(lang>0 && lang<=3){
                xlang=newlang[lang-1]
            }else{
                xlang='en'
            }
        }else{
            xlang=lang
        }

        return xlang
    },

    //获取语种Id
    getLanuageId(lang){
        let newlang=['en','zh-hk','zh-cn']
        let xlang=''
        if(isNumber(lang)){
            return lang
        }else{
            let laid=newlang.indexOf(lang)
            if(laid!=-1){
                return laid+1
            }else{
                return ''
            }
        }
    },

    //解码缓存
    getCacheTemp(data){
        let reData=null
        if(data){
            reData=JSON.parse(window.atob(data))
        }
        return reData
    },

    //加密缓存
    setCacheTemp(data){
        let reData=null
        if(data){
            reData=window.btoa(JSON.stringify(data))
        }
        return reData
    },

    //获取秘钥
    getPublicKey:function(type='',logData){
        let that=this

        //判断
        let client_pri=Lockr.get('mtrshop_client_pri')
        let client_pri_time=Lockr.get('mtrshop_client_pri_time')
        let time=(new Date().getTime())
        let reaData;

        //判断
        reaData={
            KeyId:'',
            UserId:'',
        }

        return new Promise((resolve, reject)=>{
            //判断是否存在
            if(client_pri && client_pri_time && client_pri_time>time-(3600*1000)){
                resolve(client_pri)
            }else{
                getPublicKeyApi(reaData).then(res=>{
                    let ClientPrivateKey=res.ClientPrivateKey
                    let ServicePublicKey=res.ServicePublicKey
                    if(ClientPrivateKey){
                        store.commit('SET_CLIENT_PRI', ClientPrivateKey)
                        store.commit('SET_SERVER_PRI', ServicePublicKey)
                    }
                    resolve(ClientPrivateKey)
                }).catch((error)=>{
                    console.warn('获取秘钥失败',error)
                })
            }
        })
    },
}

export default cache



// WEBPACK FOOTER //
// ./src/utils/cache.js